import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "./Breadcrumb";

interface PageHeaderProps {
  title: string;
  subtitle: string;
  crumbs: Crumb[];
  children?: ReactNode;
}

export default function PageHeader({ title, subtitle, crumbs, children }: PageHeaderProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-100/70 via-background-50 to-accent-100/60 pb-12 pt-28 md:pb-16 md:pt-32">
      <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary-200/40 blur-2xl"></div>
      <div className="pointer-events-none absolute -left-10 bottom-0 h-40 w-40 rounded-full bg-accent-200/40 blur-2xl"></div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={crumbs} />
        <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{subtitle}</p>
        {children}
      </div>
    </section>
  );
}